'use client'

import {
	FormButton,
	ResetButton,
	SubmitButton,
} from './FormButtons/FormButtons'

import { FormCheckboxGroupInput } from './FormInput/FormCheckboxInputGroup'
import { FormCheckboxInput } from './FormInput/FormCheckboxInput'
import { FormDateInput } from './FormInput/FormDateInput'
import { FormField } from './FormField/FormField'
import FormImageListUpload from './FormInput/FormImageListUpload'
import { FormImageUpload } from './FormInput/FormImageUpload'
import { FormNumericInput } from './FormInput/FormNumericInput'
import { FormPasswordInput } from './FormInput/FormPasswordInput'
import { FormProvider } from './FormProvider/FormProvider'
import { FormRadioInput } from './FormInput/FormRadioInput'
import { FormRatingInput } from './FormInput/FormRatingInput'
import { FormSelectInput } from './FormInput/FormSelectInput'
import { FormSwitchInput } from './FormInput/FormSwitchInput'
import { FormTextInput } from './FormInput/FormTextInput'
import { FormTextareaInput } from './FormInput/FormTextareaInput'

export const Form = {
	Button: FormButton,
	Checkbox: FormCheckboxInput,
	Control: FormField,
	DateInput: FormDateInput,
	ImageUpload: FormImageUpload,
	ImageListUpload: FormImageListUpload,
	GroupCheckbox: FormCheckboxGroupInput,
	NumericInput: FormNumericInput,
	PasswordInput: FormPasswordInput,
	Provider: FormProvider,
	RadioInput: FormRadioInput,
	RatingInput: FormRatingInput,
	ResetButton,
	SelectInput: FormSelectInput,
	SubmitButton,
	Switch: FormSwitchInput,
	TextareaInput: FormTextareaInput,
	TextInput: FormTextInput,
}

